
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.jpaReady === 'true') return;
    root.dataset.jpaReady = 'true';
    root.querySelectorAll('[data-jpa-request]').forEach(function (link) {
      link.addEventListener('click', function () {
        var selected = Array.from(root.querySelectorAll('input[type="radio"]')).find(function (input) {
          return input.value === link.dataset.jpaRequest;
        });
        if (selected) selected.checked = true;
      });
    });
    var faq = root.querySelector('[data-jpa-faq]');
    if (faq) faq.addEventListener('toggle', function (event) {
      var current = event.target;
      if (!current.matches('details[open]')) return;
      faq.querySelectorAll('details[open]').forEach(function (item) {
        if (item !== current) item.open = false;
      });
    }, true);
    root.querySelectorAll('[data-jpa-photo]').forEach(function (img) {
      function fallback() {
        img.hidden = true;
        var alternative = img.parentElement.querySelector('.jpa-photo-fallback');
        if (alternative) alternative.hidden = false;
      }
      img.addEventListener('error', fallback);
      if (img.complete && img.naturalWidth === 0) fallback();
    });
    var preview = root.querySelector('form[data-preview]');
    if (preview) preview.addEventListener('submit', function (event) {
      event.preventDefault();
      var notice = root.querySelector('[data-preview-status]');
      if (notice) {
        notice.hidden = false;
        notice.focus();
      }
    });
    var success = root.querySelector('[data-jpa-success]');
    if (success) success.focus();
  }
  function scan(scope) {
    if (scope.matches && scope.matches('[data-jpa]')) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-jpa]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
